import { render, staticRenderFns } from "./PesquisaTecnica.vue?vue&type=template&id=923bc138&scoped=true"
import script from "./PesquisaTecnica.vue?vue&type=script&lang=js"
export * from "./PesquisaTecnica.vue?vue&type=script&lang=js"
import style0 from "./PesquisaTecnica.vue?vue&type=style&index=0&id=923bc138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923bc138",
  null
  
)

export default component.exports